const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-f3e2ee1d-8c3c-4c30-a948-0f42becc7c80 {\n        stroke-miterlimit: 10;\n      }\n\n      .uuid-f3e2ee1d-8c3c-4c30-a948-0f42becc7c80, .uuid-716458a5-7169-49c6-aaf9-ee90c6050fc2, .uuid-610fedcb-7445-4733-935a-2f0b20e622a3 {\n        fill: none;\n        stroke: #e8e4db;\n        stroke-linecap: round;\n      }\n\n      .uuid-716458a5-7169-49c6-aaf9-ee90c6050fc2 {\n        stroke-width: 2px;\n      }\n\n      .uuid-716458a5-7169-49c6-aaf9-ee90c6050fc2, .uuid-610fedcb-7445-4733-935a-2f0b20e622a3 {\n        stroke-linejoin: round;\n      }\n\n      .uuid-f0efdd40-0902-4410-b828-c3c889a7c140 {\n        fill: #5e3524;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-9a0d0a8a-ae72-462e-9e44-4f6cb36ad749",
  "data-name": "Circles"
}, /*#__PURE__*/React.createElement("circle", {
  className: "uuid-f0efdd40-0902-4410-b828-c3c889a7c140",
  cx: 22,
  cy: 21.95,
  r: 22
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-34bd2f53-2f12-4ea3-9f41-a7216cf72a9e",
  "data-name": "Template"
}, /*#__PURE__*/React.createElement("path", {
  className: "uuid-716458a5-7169-49c6-aaf9-ee90c6050fc2",
  d: "M22.17,12.41v20.15c0,.18-.19.3-.35.21-1.11-.6-2.76-1.39-4.48-1.86-1.82-.48-3.54-.62-4.83-.62-.41,0-.78,0-1.09.02-.14,0-.25-.1-.25-.24V11.03h-.05v-1.41c0-.12.09-.22.21-.24,1.14-.13,3.38-.17,5.57.55,1.1.33,2.01.72,2.82,1.1.57.24,1.1.53,1.48.72.32.16.61.32.84.46.07.04.12.12.12.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-716458a5-7169-49c6-aaf9-ee90c6050fc2",
  d: "M33.21,9.62v20.45c0,.14-.11.25-.25.24-1.3-.08-3.59-.08-5.96.59-1.72.47-3.36,1.26-4.48,1.86-.16.09-.35-.03-.35-.21V12.4c0-.08.04-.15.1-.2.2-.13.49-.26.85-.46.38-.24.91-.48,1.48-.72.81-.38,1.77-.76,2.82-1.1,2.19-.71,4.42-.64,5.56-.54.12,0,.22.11.22.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-f3e2ee1d-8c3c-4c30-a948-0f42becc7c80",
  d: "M25.28,16.6s2.24-1.59,4.82-1.56"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-f3e2ee1d-8c3c-4c30-a948-0f42becc7c80",
  d: "M25.28,21.13s2.24-1.59,4.82-1.56"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-f3e2ee1d-8c3c-4c30-a948-0f42becc7c80",
  d: "M25.28,25.67s2.24-1.59,4.82-1.56"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-f3e2ee1d-8c3c-4c30-a948-0f42becc7c80",
  d: "M19.06,16.6s-2.24-1.59-4.82-1.56"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-f3e2ee1d-8c3c-4c30-a948-0f42becc7c80",
  d: "M19.06,21.12s-2.24-1.59-4.82-1.56"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-f3e2ee1d-8c3c-4c30-a948-0f42becc7c80",
  d: "M19.06,25.66s-2.24-1.59-4.82-1.56"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-610fedcb-7445-4733-935a-2f0b20e622a3",
  d: "M33.21,12.76h3.14c.28,0,.5.22.5.5v19.71c0,.28-.22.5-.5.5H8c-.28,0-.5-.22-.5-.5V13.26c0-.28.22-.5.5-.5h3.14"
}));
function SvgRepozeIconCategoryBooks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepozeIconCategoryBooks);
export default __webpack_public_path__ + "static/media/repoze_icon_category-books.822ea63a59b0e31fad0fb3fa7745cfc8.svg";
export { ForwardRef as ReactComponent };